<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Country</div>
      <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="addNew()">Add New</button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- {{ setContent(content) }} -->

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    <form #userForm="ngForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Display Name</label>
              <input type="text" class="form-control" name="display_name" #displayName="ngModel"
                [(ngModel)]="dataObj.displayName" required (blur)="checkDuplicateCountry()">
            </div>
            @if (duplicateDisplayNameError) {
              <div class="text-danger">
                {{ duplicateDisplayNameError }}
              </div>
            }
            @if (displayName.touched && displayName.invalid && !duplicateDisplayNameError) {
              <div class="text-danger">
                Please enter the display name
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Country Code</label>
              <input type="text" maxlength="2" class="form-control" name="country_code"
                #countryCode="ngModel" [(ngModel)]="dataObj.country_code" required (blur)="checkDuplicateCountry()">
            </div>
            @if (duplicateCountryCodeError) {
              <div class="text-danger">
                {{ duplicateCountryCodeError }}
              </div>
            }
            @if (countryCode.touched && countryCode.invalid && !duplicateCountryCodeError) {
              <div class="text-danger">
                Please enter the country code
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Dialing Code</label>
              <input type="text" maxlength="4" class="form-control" name="dialing_code"
                #dialingCode="ngModel" [(ngModel)]="dataObj.dialingCode" [pattern]="pattern.countryCode"
                required>
            </div>
            @if (dialingCode.touched && dialingCode.invalid) {
              <div class="text-danger">
                {{ dialingCode.errors?.['pattern'] ? "Please enter valid dialing code (Eg:+91,+972)"
                :
                "Please enter the dialing code" }}
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Currency</label>
              <select class="form-control form-select" name="curr" #currncy="ngModel"
                [(ngModel)]="dataObj.currency" required>
                @for (crncy of currencies; track crncy) {
                  <option [value]="crncy._id">
                    {{ crncy.name }}
                  </option>
                }
              </select>
            </div>
            @if (currncy.touched && currncy.invalid) {
              <div class="text-danger">
                Please select Currency
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Icon Path</label>
              <div class="input-group">
                <input type="text" class="form-control" name="icon" #icon="ngModel"
                  [(ngModel)]="dataObj.icon" required>
                @if (dataObj.icon) {
                  <span class="input-group-text">
                    <img [src]="dataObj.icon" style="max-height: 38px; max-width: 100px; object-fit: contain;">
                  </span>
                }
              </div>
            </div>
            @if (icon.touched && icon.invalid) {
              <div class="text-danger">
                Please enter the icon path
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-check mt-4">
              <input class="form-check-input" type="checkbox" id="isOrigination" [(ngModel)]="dataObj.isOrigination" name="isOrigination">
              <label class="form-check-label" for="isOrigination">
                Source Country
              </label>
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-check mt-4">
              <input class="form-check-input" type="checkbox" id="isRecipient" [(ngModel)]="dataObj.isRecipient" name="isRecipient">
              <label class="form-check-label" for="isRecipient">
                Destination Country
              </label>
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-check mt-4">
              <input class="form-check-input" type="checkbox" id="isRemittance" [(ngModel)]="dataObj.isRemittance" name="isRemittance" (change)="onRemittanceChange($event)">
              <label class="form-check-label" for="isRemittance">
                Remittance
              </label>
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Status</label>
              <select class="form-control form-select" name="status" #status="ngModel"
                [(ngModel)]="dataObj.status" required>
                <option value="Active">Active</option>
                <option value="In-Active">In-Active</option>
              </select>
            </div>
            @if (status.touched && status.invalid) {
              <div class="text-danger">
                Please select status
              </div>
            }
          </div>

          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label>DOB Format</label>
              <select class="form-control form-select" name="dobFormat" #dobFormatField="ngModel"
                [(ngModel)]="dataObj.dobFormat">
                <option value="DD-MM-YYYY">DD-MM-YYYY</option>
                <option value="MM-DD-YYYY">MM-DD-YYYY</option>
                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
              </select>
            </div>
          </div>

          <div class="col-md-12">
            <h5 class="mt-2 btn btn-primary mt-5 text-start bg-primary-subtle text-primary border-0 w-100">Mobile Number Rules</h5>
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Mobile Number Pattern</label>
              <input type="text" class="form-control" required name="mobileNumberPattern" #mobileNumberPattern="ngModel"
                [(ngModel)]="dataObj.mobileNumberPattern" required>
            </div>
            @if (mobileNumberPattern.touched && mobileNumberPattern.invalid) {
              <div class="text-danger">
                Please enter the Pattern
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Mobile Number Place Holder</label>
              <input type="text" class="form-control" required name="mobileNumberPlaceHolder" #mobileNumberPlaceHolder="ngModel"
                [(ngModel)]="dataObj.mobileNumberPlaceHolder" required>
            </div>
            @if (mobileNumberPlaceHolder.touched && mobileNumberPlaceHolder.invalid) {
              <div class="text-danger">
                Please enter the Pattern
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Mobile Number Max Length</label>
              <input type="text" class="form-control" required name="mobileNumberMaxLength" #mobileNumberMaxLength="ngModel"
                [(ngModel)]="dataObj.mobileNumberMaxLength" required>
            </div>
            @if (mobileNumberMaxLength.touched && mobileNumberMaxLength.invalid) {
              <div class="text-danger">
                Please enter the Rules
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="">Mobile Number Rules</label>
              <input type="text" class="form-control" name="mobileNumberRules" #mobileNumberRules="ngModel"
                [(ngModel)]="dataObj.mobileNumberRules">
            </div>
            @if (mobileNumberRules.touched && mobileNumberRules.invalid) {
              <div class="text-danger">
                Please enter the Rules
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="">Mobile Number Separator</label>
              <input type="text" class="form-control" name="mobileNumberSeparator" #mobileNumberSeparator="ngModel"
                [(ngModel)]="dataObj.mobileNumberSeparator">
            </div>
            @if (mobileNumberSeparator.touched && mobileNumberSeparator.invalid) {
              <div class="text-danger">
                Please enter the Rules
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Mobile Number Validation Message</label>
              <input type="text" class="form-control" required name="mobileNumberValidationMessage" #mobileNumberValidationMessage="ngModel"
                [(ngModel)]="dataObj.mobileNumberValidationMessage">
            </div>
            @if (mobileNumberValidationMessage.touched && mobileNumberValidationMessage.invalid) {
              <div class="text-danger">
                Please enter the Mobile Number Validation Message
              </div>
            }
          </div>
          <div class="col-md-12">
            <h5 class="mt-2 btn btn-primary mt-5 text-start bg-primary-subtle text-primary border-0 w-100">Driving Licence Rules</h5>
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">DL Pattern</label>
              <input type="text" class="form-control" #dlPattern="ngModel" name="dlPattern"
                [(ngModel)]="dataObj.dlPattern" required>
            </div>
            @if (dlPattern.touched && dlPattern.invalid) {
              <div class="text-danger">
                Please enter the DL Pattern
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">DL Place Holder</label>
              <input type="text" class="form-control" #dlPlaceHolder="ngModel" name="dlPlaceHolder"
                [(ngModel)]="dataObj.dlPlaceHolder" required>
            </div>
            @if (dlPlaceHolder.touched && dlPlaceHolder.invalid) {
              <div class="text-danger">
                Please enter the DL Place Holder
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">DL Max Length</label>
              <input type="text" class="form-control" #dlMaxLength="ngModel" name="dlMaxLength"
                [(ngModel)]="dataObj.dlMaxLength" required>
            </div>
            @if (dlMaxLength.touched && dlMaxLength.invalid) {
              <div class="text-danger">
                Please enter the DL Max Length
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="">DL Rules</label>
              <input type="text" class="form-control" name="dlRules" #dlRules="ngModel"
                [(ngModel)]="dataObj.dlRules">
            </div>
            @if (dlRules.touched && dlRules.invalid) {
              <div class="text-danger">
                Please enter the DL Rules
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="">DL Separator</label>
              <input type="text" class="form-control" name="dlSeparator" #dlSeparator="ngModel"
                [(ngModel)]="dataObj.dlSeparator">
            </div>
            @if (dlSeparator.touched && dlSeparator.invalid) {
              <div class="text-danger">
                Please enter the DL Separator
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">DL Validation Message</label>
              <input type="text" class="form-control" required name="dlValidationMessage" #dlValidationMessage="ngModel"
                [(ngModel)]="dataObj.dlValidationMessage">
            </div>
            @if (dlValidationMessage.touched && dlValidationMessage.invalid) {
              <div class="text-danger">
                Please enter the DL Validation Message
              </div>
            }
          </div>
          <div class="col-md-12">
            <h5 class="mt-2 btn btn-primary mt-5 text-start bg-primary-subtle text-primary border-0 w-100">Passport Rules</h5>
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Passport Pattern</label>
              <input type="text" class="form-control" #passportPattern="ngModel" name="passportPattern"
                [(ngModel)]="dataObj.passportPattern" required>
            </div>
            @if (passportPattern.touched && passportPattern.invalid) {
              <div class="text-danger">
                Please enter the Passport Pattern
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Passport Place Holder</label>
              <input type="text" class="form-control" #passportPlaceHolder="ngModel" name="passportPlaceHolder"
                [(ngModel)]="dataObj.passportPlaceHolder" required>
            </div>
            @if (passportPlaceHolder.touched && passportPlaceHolder.invalid) {
              <div class="text-danger">
                Please enter the Passport Place Holder
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Passport Max Length</label>
              <input type="text" class="form-control" #passportMaxLength="ngModel" name="passportMaxLength"
                [(ngModel)]="dataObj.passportMaxLength" required>
            </div>
            @if (passportMaxLength.touched && passportMaxLength.invalid) {
              <div class="text-danger">
                Please enter the Passport Max Length
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="">Passport Rules</label>
              <input type="text" class="form-control" name="passportRules" #passportRules="ngModel"
                [(ngModel)]="dataObj.passportRules">
            </div>
            @if (passportRules.touched && passportRules.invalid) {
              <div class="text-danger">
                Please enter the Passport Rules
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="">Passport Separator</label>
              <input type="text" class="form-control" name="passportSeparator" #passportSeparator="ngModel"
                [(ngModel)]="dataObj.passportSeparator">
            </div>
            @if (passportSeparator.touched && passportSeparator.invalid) {
              <div class="text-danger">
                Please enter the Passport Separator
              </div>
            }
          </div>
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Passport Validation Message</label>
              <input type="text" class="form-control" required name="passportValidationMessage" #passportValidationMessage="ngModel"
                [(ngModel)]="dataObj.passportValidationMessage">
            </div>
            @if (passportValidationMessage.touched && passportValidationMessage.invalid) {
              <div class="text-danger">
                Please enter the Passport Validation Message
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-2 text-center">
            <button [disabled]="!userForm.valid || duplicateDisplayNameError || duplicateCountryCodeError" class="btn btn-primary active mt-4 w-50"
            (click)="onSubmit(userForm.valid)">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!-- Remittance Warning Modal -->
<ng-template #remittanceWarningModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="remittance-warning-title">Remittance Configuration Warning</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-4">Make sure you have completed the following configurations before enabling remittance for this country:</p>

    <div class="alert alert-warning">
      <h5>Important Configurations:</h5>
      <ul class="mb-0">
        <li>
          <strong>Dynamic Fields for Beneficiary:</strong>
          <a (click)="openDynamicFieldsLink()" class="ms-1" style="cursor: pointer;">
            Check Dynamic Fields Configuration
          </a>
        </li>
        <li>
          <strong>Billers Configuration:</strong>
          <a (click)="openBillsLink()" class="ms-1" style="cursor: pointer;">
            Check Billers Configuration
          </a>
        </li>
      </ul>
    </div>

    <div class="alert alert-info">
      <h5>Why this is important:</h5>
      <p class="mb-0">
        Enabling remittance without these configurations will cause errors in the mobile app, resulting in a poor user experience.
        As an admin, you must ensure all necessary configurations are completed before a country can be used for remittance.
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">I Understand</button>
  </div>
</ng-template>